/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function DiffRemoved({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15" {...props}><path fill="currentColor" d="M3.6 6.5a.6.6 0 0 0 0 1.2h7a.6.6 0 1 0 0-1.2h-7Z" /><path fill="currentColor" fillRule="evenodd" d="M2.6 0A2.6 2.6 0 0 0 0 2.6v9a2.6 2.6 0 0 0 2.6 2.6h9a2.6 2.6 0 0 0 2.6-2.6v-9A2.6 2.6 0 0 0 11.6 0h-9ZM1.2 2.6a1.4 1.4 0 0 1 1.4-1.4h9A1.4 1.4 0 0 1 13 2.6v9a1.4 1.4 0 0 1-1.4 1.4h-9a1.4 1.4 0 0 1-1.4-1.4v-9Z" clipRule="evenodd" /></svg>;
}
;